import { defineMessages } from 'react-intl';

import { UserPreFillData } from '../types/Account';
import { Message } from '../types/common';
import { redirects } from './redirects';
import { routes } from './routing';

export type AccountNavigationItem = {
  route: Message;
  title: Message;
};

const messages = defineMessages({
  overviewTitle: {
    id: 'src.constants.account.overviewTitle',
    defaultMessage: 'Overview',
  },
  detailsTitle: {
    id: 'src.constants.account.detailsTitle',
    defaultMessage: 'Details',
  },
  ordersTitle: {
    id: 'src.constants.account.ordersTitle',
    defaultMessage: 'Orders',
  },
});

export const ACCOUNT_NAVIGATION_LIST: AccountNavigationItem[] = [
  {
    title: messages.overviewTitle,
    route: redirects.accountOverviewPageRedirect,
  },
  {
    title: messages.detailsTitle,
    route: redirects.accountDataPageRedirect,
  },
  {
    title: messages.ordersTitle,
    route: redirects.accountOrdersPageRedirect,
  },
];

export const ACCOUNT_ROUTES = [
  routes.accountOverviewPageRoute,
  routes.accountDataPageRoute,
  routes.accountOrdersPageRoute,
];

export const defaultUserPreFillData: UserPreFillData = {
  firstName: '',
  lastName: '',
  email: '',
};
